import React from 'react';
import api from './../../../services/api';
import { user_token } from '../../../services/Auth';

import {agent} from '../../../services/api';
let apiAgent = new agent();

var token = localStorage.getItem(user_token);

export default class GetExam extends React.Component {
  state = {
    consulta: []
  }
  filter = [{
    header: 'user_id',
    value: 'this.props.id'
  }]
  componentDidMount() {
    //api.get(`/exam/user/${this.props.id}`, {headers: {'x-access-token': token}})
    apiAgent.getAllUserExams(this.props.id)
      .then(res => {
        const consulta = res.data;
        this.setState({ consulta });
        console.log("consulta ===>", res.data)
      })
  }

  render() {
    return (
      <ul>
        { this.state.consulta.map(details => 
        <>       
          <hr id="coloring_line"/>         
          <p id="RI-Title-Cadastro-Paciente" >Tipo de Atendimento: </p><p>{details.appointment_type}</p>
          <p id="RI-Title-Cadastro-Paciente" >Especialidade Requerida: </p><p>{details.medical_appointment_type}</p>
          <p id="RI-Title-Cadastro-Paciente" >E-mail do(a) Representante da Instituição: </p><p>{details.appointment_purpose}</p>
          <p id="RI-Title-Cadastro-Paciente" >Período: </p><p>{details.appointment_period}</p>
          <p id="RI-Title-Cadastro-Paciente" >Observações: </p><p>{details.notes}</p>
          <p id="RI-Title-Cadastro-Paciente" >Prescrição Médica: </p><p>{details.prescription}</p>
          <p id="RI-Title-Cadastro-Paciente" >Horário: </p><p>{details.appointment_date} </p>
          <p id="RI-Title-Cadastro-Paciente" >Status da Consulta: </p><p>{details.status}</p>       
          <hr id="coloring_line"/>
          <br></br>
        </>)}
      </ul>
    )
  }
}